var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { jsx, Fragment, jsxs } from "react/jsx-runtime";
import * as React from "react";
import logger, { ErrorType } from "@ane/core/lib/services/logging/Logger";
import "../MessageBar/index.js";
import { MessageBar } from "../MessageBar/MessageBar.js";
import { MessageBarType } from "@fluentui/react/lib/MessageBar";
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "_onRenderError", (state) => {
      return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(
        MessageBar,
        {
          ariaLabel: "There was an error",
          messageBarType: MessageBarType.severeWarning,
          isMultiline: false,
          dismissButtonAriaLabel: "Close",
          truncated: true,
          overflowButtonAriaLabel: "View error details",
          children: [
            /* @__PURE__ */ jsx("b", { children: "There was an error:" }),
            " ",
            this.state.error
          ]
        }
      ) });
    });
    this.state = { hasError: false, error: "" };
  }
  componentDidCatch(error, info) {
    let errorMessage = "Something went wrong";
    let errorStack = "[unset]";
    let logMessage = "[unset]";
    if (typeof error == "string") {
      errorMessage = error;
      logMessage = error + " -- developer: do not throw plain string exceptions, they do not have a proper stack, throw Error() instead";
      errorStack = "no stack with string exceptions";
    } else {
      errorMessage = logMessage = error.message;
      errorStack = error.stack || "";
    }
    const componentStack = (info == null ? void 0 : info.componentStack) || "";
    let message = `${errorMessage}. ${componentStack}`;
    this.setState({ hasError: true, error: message });
    logger.error(logMessage, ErrorType.ErrorBoundary, { suppressPopup: true, errorStack, info });
  }
  render() {
    const { onRenderError = this._onRenderError } = this.props;
    if (this.state.hasError) {
      return onRenderError(this.state);
    }
    return this.props.children;
  }
}
export {
  ErrorBoundary,
  ErrorBoundary as default
};
//# sourceMappingURL=ErrorBoundary.js.map
